// Detect Firefox
export const isFireFox = window.navigator.userAgent.indexOf('Firefox') > -1;

// Detect Safari
export const isSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);
